/**
 * 全局配置 main.js导入
 */
console.log("%c编译环境：", "color:#f00", process.env.NODE_ENV);
export default class Config {
  /**
   * @param api axios [this.api.*] 调用
   */
  constructor() {
    this.api = process.env.NODE_ENV == "development" ? require("../../static/js/api/dev"): require("../../static/js/api/prod");
  }
}


// WEBPACK FOOTER //
// ./src/utils/IPconfig.js